/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActualRegionalExposureResponseViewModel
 */
export interface ActualRegionalExposureResponseViewModel {
    /**
     * 
     * @type {string}
     * @memberof ActualRegionalExposureResponseViewModel
     */
    fundName: string;
    /**
     * 
     * @type {number}
     * @memberof ActualRegionalExposureResponseViewModel
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualRegionalExposureResponseViewModel
     */
    local?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualRegionalExposureResponseViewModel
     */
    foreign?: number;
    /**
     * 
     * @type {string}
     * @memberof ActualRegionalExposureResponseViewModel
     */
    id?: string;
}

/**
 * Check if a given object implements the ActualRegionalExposureResponseViewModel interface.
 */
export function instanceOfActualRegionalExposureResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fundName" in value;

    return isInstance;
}

export function ActualRegionalExposureResponseViewModelFromJSON(json: any): ActualRegionalExposureResponseViewModel {
    return ActualRegionalExposureResponseViewModelFromJSONTyped(json, false);
}

export function ActualRegionalExposureResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActualRegionalExposureResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fundName': json['FundName'],
        'percentage': !exists(json, 'Percentage') ? undefined : json['Percentage'],
        'local': !exists(json, 'Local') ? undefined : json['Local'],
        'foreign': !exists(json, 'Foreign') ? undefined : json['Foreign'],
        'id': !exists(json, 'Id') ? undefined : json['Id'],
    };
}

export function ActualRegionalExposureResponseViewModelToJSON(value?: ActualRegionalExposureResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FundName': value.fundName,
        'Percentage': value.percentage,
        'Local': value.local,
        'Foreign': value.foreign,
        'Id': value.id,
    };
}

